<template>
    <div>
        <!-- 风格：绿色渐变圆角按钮 -->
        <div class="download-btn btn-style-green" @click="clk" :class="{mg: mg}">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            {{ value }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['value','mg','href'],
    methods: {
        clk() {
            if (this.href) {
                window.location.href = this.href;
                return;
            }
            if (this.$route.name !== 'download') {
                window.location.href = '/download/';
            } else if (this.$parent && typeof this.$parent.download === 'function') {
                // 下载页触发父组件下载
                this.$parent.download();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mg {
  margin: 20px auto;
}
.download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 20px;
    font-weight: 600;
    width: 300px;
    height: 50px;
  
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;

    .icon {
        width: 20px;
        height: 20px;
        stroke: white;
    }
}

// ------------------------------
// 绿色渐变圆角按钮
// ------------------------------
.btn-style-green {
    background: linear-gradient(90deg, #28a745, #218838);
    color: white;

    .icon {
        stroke: white;
    }

    &:hover {
        background: linear-gradient(90deg, #218838, #28a745);
    }
}
</style>
